const tagFields = {
	LM: "F135",
	CM: "F136",
	AM: "F137",
	OM: "F138",
	MSG: "F139",
	ACTM: "F164",
};

export default tagFields;
